module.exports = __webpack_public_path__ + "static/media/icon-advisory.94346203.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-advisory.svg
// module id = 525
// module chunks = 0